import type { ReactNode } from 'react';

import { Text } from '../text/text';

export interface InputHelpProps {
  children?: ReactNode;
}

export const InputHelp = ({ children }: InputHelpProps) => {
  return (
    <Text Component="span" variant="caption150">
      {children}
    </Text>
  );
};
